import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { isValidPatientId } from "utils/isValidPatientId";

export const usePatientName = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientName", tenantVal, patientId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patient/get/${patientId}`
      );
      return response.data;
    },
    enabled: !!tenantVal && isValidPatientId(patientId),
    staleTime: 1000 * 60 * 10,
    retry: false,
  });
};
